import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import Header from "../Window/Header";
import Main from "../Steps/Main";
import Footer from "../Window/Footer";
import Checkout from "../Steps/Checkout";
import ContactStep from "../Steps/ContactStep";

import './style.scss';
import Loader from "../Loader";
import SessionTimeout from "../TimerCloseSession/SessionTimeout";
import { useGetTokenQuery, useGetProductsMutation } from "../../redux/api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { isMainLoader } from "../../redux/slices/windowSlice";

const App = () => {

    const dispatch = useAppDispatch();
    const { stepCurrent } = useAppSelector((state: RootState) => state.windowSlice);

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();

    const { data: getToken } = useGetTokenQuery();
    const [ getProducts, { data: tempProducts } ] = useGetProductsMutation();

    useEffect(() => {
        if(getToken) {
            getProducts(searchParams.get("ticket_id"));
        }
    }, [getToken, getProducts, searchParams]);

    useEffect(() => {
        if(tempProducts) {
            dispatch(isMainLoader(false));
        }
    }, [tempProducts, dispatch]);

    const getWindow = () => {
        switch (stepCurrent) {
            case 0:
                return "order-mode";
            case 1:
                return "order-mode checkout-step";
            case 2: 
                return "order-mode contact-step";
            case 3: 
                return "order-mode payment";        
        }
    }

    return (
        <div className="modal">
            <Loader />
            <SessionTimeout/>  
            <Header />
            <div className={getWindow()}>
                <Main />  
                <Checkout />
                <ContactStep />
            </div>
            <Footer />
        </div>
    );
}

export default App;